/**
Author - Venkatesh Pullaganti😃
Git - https://github.com/venkatesh1146
**/

import IMAGES from './Images';

export const AA_POLLING_INTERVAL = 15000; // 15 seconds
export const AA_MAX_POLLING_ATTEMPTS = 10; // 1 hour max (240 * 15s)

export const VIEW_STATES = {
  INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  POLLING: 'POLLING',
  FAILED: 'FAILED',
  SKIP_FLOW: 'SKIP_FLOW',
};

export const AA_CONSENT_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED',
};

export const AA_PROCESSING_STATUS = {
  PROCESSING: 'PROCESSING',
  FETCHING: 'FETCHING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
};

export const AA_STATUS_MESSAGES = {
  PENDING: {
    title: 'Waiting for Approval',
    description: 'Please verify the consent in the opened window to continue.',
    image: IMAGES.clockIcon,
  },
  ACTIVE_FETCHING: {
    title: 'Request received. Thank You for the Verification!',
    description:
      'We are verifying the income details. It might take a few hours to complete verification. You can close this screen now',
    image: IMAGES.verifying_clock,
  },
  ACTIVE_WAITING_FOR_CONSENT_APPROVAL: {
    title: 'Waiting for your consent approval',
    description: 'Please complete the OTP verification in the opened tab',
    image: IMAGES.verifying_clock,
  },
  REJECTED: {
    title: 'Verification Request Rejected',
    description: 'You have rejected the verification request.',
    image: IMAGES.closeImage,
  },
  EXPIRED: {
    title: 'Verification Request Expired',
    description: 'The verification request has expired. Please try again.',
    image: IMAGES.clockIcon,
  },
  FAILED: {
    title: 'Verification Failed',
    description: 'We could not verify your bank account through OTP.',
    image: IMAGES.arnFailed,
  },
  CREATE_NEW: {
    title: 'Previous Request Expired',
    description:
      'Your previous verification request has expired. Please create a new request or upload bank statement.',
    image: IMAGES.clockIcon,
  },
};

export const AA_STATUS_MESSAGES_ALL_FI = {
  ACTIVE_FETCHING: {
    title: 'Request received. Thank you!',
    description:
      'We are fetching your account data. It might take a few hours to reflect in your net worth. You can close this screen now',
    image: IMAGES.verifying_clock,
  },
  ACTIVE_WAITING_FOR_CONSENT_APPROVAL: {
    title: 'Waiting for your consent approval',
    description: 'Please complete the verification in the opened tab',
    image: IMAGES.verifying_clock,
  },
  REJECTED: {
    title: 'Request Rejected',
    description: 'You have rejected the account connection request.',
    image: IMAGES.closeImage,
  },
  EXPIRED: {
    title: 'Request Expired',
    description: 'The connection request has expired. Please try again.',
    image: IMAGES.clockIcon,
  },
  FAILED: {
    title: 'Connection Failed',
    description: 'We could not connect your account. Please try again.',
    image: IMAGES.arnFailed,
  },
};
